exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mpx-iframe{width:100%;height:100%;position:absolute;left:0;top:0;right:0;bottom:0}", ""]);

// exports
